import numeral from "numeral";

export function money(value) {
  const f = parseFloat(String(value || 0));
  return `${numeral(f).format("$0,0")}.00`;
}
